import React from "react";
import { secondaryColor } from "../../utils/constants";

export default function MenuOpen({ color = secondaryColor }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="22" viewBox="0 0 42.8 18.8">
      <g id="Nav-Open" transform="translate(-30.1 -48.1)">
        <path
          id="Vereinigungsmenge_2"
          data-name="Vereinigungsmenge 2"
          d="M148.4-144.6A1.4,1.4,0,0,1,147-146a1.4,1.4,0,0,1,1.4-1.4h27a1.4,1.4,0,0,1,1.4,1.4,1.4,1.4,0,0,1-1.4,1.4Zm-9,0A1.4,1.4,0,0,1,138-146a1.4,1.4,0,0,1,1.4-1.4h2a1.4,1.4,0,0,1,1.4,1.4,1.4,1.4,0,0,1-1.4,1.4Zm11-8A1.4,1.4,0,0,1,149-154a1.4,1.4,0,0,1,1.4-1.4h27a1.4,1.4,0,0,1,1.4,1.4,1.4,1.4,0,0,1-1.4,1.4Zm-7,0A1.4,1.4,0,0,1,142-154a1.4,1.4,0,0,1,1.4-1.4h1a1.4,1.4,0,0,1,1.4,1.4,1.4,1.4,0,0,1-1.4,1.4Zm9-8A1.4,1.4,0,0,1,151-162a1.4,1.4,0,0,1,1.4-1.4h27a1.4,1.4,0,0,1,1.4,1.4,1.4,1.4,0,0,1-1.4,1.4Z"
          transform="translate(-107.9 211.5)"
          fill={color}
        />
      </g>
    </svg>
  );
}
